import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { ManageWorkersCreate } from '@components/templates/myAccount/manageWorkersCreate';

export function ManageWorkersCreatePage() {
    const { store } = useParams();
    const { t } = useTranslation();

    const translations = {
        title: t('manage-workers-create-component.metatags.title'),
        description: t('manage-workers-create-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myWorkersCreate.replace(':store', `${store}`),
        index: false,
    });

    return <ManageWorkersCreate />;
}
